import React from 'react';
import { Bar, LinearLoaderContainer, LinearLoaderWrapper } from './LinearLoaderStyles';

interface IProps {
  className?: string;
}
export const LinearLoader: React.FC<IProps> = (props) => {
  return (
    <LinearLoaderContainer>
      <LinearLoaderWrapper className={`linear-loader ${props.className || ''}`}>
        <Bar className='bar' />
      </LinearLoaderWrapper>
    </LinearLoaderContainer>
  );
};
